import React from "react";
import LoginTemplate from "../../templates/Login";

const Login: React.FunctionComponent = () => <LoginTemplate />;

export default Login;
